import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import { EnhancedMembershipsList } from "../../components/memberships-list/enhanced-memberships-list";
import { Button, Typography, Link as MuiLink } from "@mui/material";
import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Link } from "react-router";
import { Pages } from "../../utils";
import { useState } from "react";
import { PolicyPopup } from "./policy-popup";

export const HomeownerMembershipPricingPage = () => {
  const [showPolicyPopup, setShowPolicyPopup] = useState(false);

  return (
    <div className="page membership-pricing-page">
      <MaterialHero title="HOMEOWNER MEMBERSHIP LEVELS" />
      <LandingPageSection className="text-center">
        <Typography
          variant="h4"
          component="h2"
          sx={{ mb: "16px" }}
          className="font-size-5 font-body text-pink"
        >
          Transparent Pricing & Results Reporting
        </Typography>
        <Typography
          variant="body1"
          sx={{ mx: "auto", mb: "40px" }}
          className="font-size-3 description contain-text"
        > Homeowner memberships renew automatically at the end of
          each billing period. Choose files-only or full Guild access. See what’s included in each plan below.{" "}
          <MuiLink
            color={"purple" as any}
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => setShowPolicyPopup(true)}
          >
            view our membership & renewal policy.
          </MuiLink>
        </Typography>
        <LandingPageSection className="text-left contain-text" sx={{ mt: "-60px" }}>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert variant="outlined" severity="info">
              <>
                <Typography
                  sx={{ fontWeight: 600, mb: "16px" }}
                  variant="body1"
                  className="font-size-4 text-left font-body"
                >
                  How billing works
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ mb: "8px", mx: "auto" }}
                  className="font-size-4 text-left font-body"
                >
                  <strong>Guild</strong> is billed monthly.{" "}
                  <strong>Guild&nbsp;+</strong> is billed annually.{" "}
                  <strong>Basic</strong> is free.
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ mb: "40px", mx: "auto" }}
                  className="font-size-4 text-left font-body"
                >
                  You can change plans or turn off auto-renew any time in your account
                  before the next renewal date.
                </Typography>
              </>
            </Alert>
          </Stack>          
        </LandingPageSection>

        <EnhancedMembershipsList
          variant="homeowner"
          showBetaPlans={false}
          showPlaceholders={false}
        />
      </LandingPageSection>

      <LandingPageSection className="pink-section text-center">
        <Typography
          mb="20px"
          variant="h4"
          sx={{ fontWeight: 600 }}
          className="font-size-5 font-body title"
        >
          Start Your Project With Home Design Guild.
        </Typography>
        <Typography
          mb="52px"
          variant="h6"
          component="p"
          fontWeight={400}
          className="text-white"
        >
          Get matched to designers and explore ideas with the plan that fits you.
        </Typography>
        <Button
          component={Link}
          to={Pages.SIGNUP}
          color={"white" as any}
          variant="contained"
          size="large"
          sx={{ fontWeight: 600 }}
          className="font-size-3 font-body"
        >
          Get Started
        </Button>
      </LandingPageSection>
      <PolicyPopup
        onClose={() => setShowPolicyPopup(false)}
        visible={showPolicyPopup}
      />
    </div>
  );
};
